// 系统用户列表筛选条件
export let systemTableFilter = [
  {
    label: '角色',
    type: 'select',
    clearable: true,
    filterable: true,
    value: 'role',
    options: [],
    props: {
      label: 'displayName',
      value: 'id'
    }
  }
]
// 系统用户列表表头
export let systemTableLabels = [
  {
    label: '用户名',
    value: 'username'
  },
  {
    label: '姓名',
    value: 'firstName'
  },
  {
    label: '性别',
    value: 'sex'
  },
  {
    label: '手机号',
    value: 'mobile'
  },
  {
    label: '所属公司',
    value: 'organizationName'
  },
  {
    label: '角色',
    value: 'role_display_name',
    minWidth: 120
  }
]
